import React, {Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import { Panel, Badge, Button } from 'react-bootstrap';
import { withRouter } from 'react-router';
import ReactStars from 'react-stars';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import { fetchErrorsFilter } from '../actions/errorActions';
import { loginUser, logoutUser, registerUser } from '../actions/userActions';
import { fetchTagCounts } from '../actions/tagActions';
import { fetchSubjects, newSubject } from '../actions/subjectActions';


class ErrorsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      tags: [],
      currentSubject: -1,
      columns : [{
        dataField: 'id',
        text: '编号',
        headerStyle:(colum,colIndex)=>{return{width:'35px'};}
      },{
        dataField: 'ddate',
        text: '日期',
        headerStyle:(colum,colIndex)=>{return{width:'100px'};}
      },{
        dataField: 'source',
        text: '来源'
      },{
        dataField: 'question_type',
        text: '题型',
        headerStyle:(colum,colIndex)=>{return{width:'110px'};}
      },{
        dataField: 'cause',
        text: '出错原因'
      },{
        dataField: 'stars',
        text: '掌握程度',
        headerStyle:(colum,colIndex)=>{return{width:'80px'};}
      },
      {
        dataField: 'tag_list',
        text: '知识点'
      }]
    }
    this.onFilerClick = this.onFilerClick.bind(this);
    this.onPrintClick = this.onPrintClick.bind(this);
    this.onPrintAnswerClick = this.onPrintAnswerClick.bind(this);
    this.addSubjectClick = this.addSubjectClick.bind(this);
  }

  componentDidMount() {
    if ((Object.keys(this.props.userinfo) !== 0) && ('token' in this.props.userinfo)) {
      this.props.fetchSubjects(this.props.userinfo.token);
      this.props.fetchTagCounts(this.props.userinfo.token);
      if (this.props.history.location.pathname.includes('=')) {
        this.props.fetchErrorsFilter(this.props.userinfo.token,this.props.history.location.pathname.slice(this.props.history.location.pathname.lastIndexOf('/')+1,200));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.errors) !== 0) {
      this.setState({errors:[]});
        let results = [];
        let errors = nextProps.errors;
        let tags = this.props.tags;
        errors.forEach((error)=>{
          let newerror = {};
          let tag_list = [];
          error.tags.forEach((tag)=>{
            if (tags.length>0) {
              var ttt = tags.find(t=>parseInt(t.id,0)===parseInt(error.subject,0));
              if ('tags' in ttt) {
                ttt = ttt.tags;
              } else {
                ttt = []
              }
              var tt = ttt.find(t=>parseInt(t.key,0)===parseInt(tag,0));
              if (tt) {
                tag_list.push(
                  <a key={tt.key} id={tt.key} nohref="true" onClick={()=>this.onFilerClick('tag='+tt.key)}>
                    {tt.value}<Badge>{tt.count}</Badge>
                  </a>
                );
              }
            }
          });
          newerror['key'] = error.id;
          newerror['id'] = <a nohref="true" onClick={()=>this.props.history.push(`/error/`+error.id)}>{error.id}</a>
          newerror['source'] = <a nohref="true" onClick={()=>this.onFilerClick('source='+error.source + '&subject='+error.subject)}>{error.source}</a>
          newerror['ddate'] = <a nohref="true" onClick={()=>this.onFilerClick('ddate='+error.ddate +'&subject='+error.subject)}>{error.ddate}</a>
          newerror['question_type'] = <a nohref="true" onClick={()=>this.onFilerClick('question_type='+error.question_type+'&subject='+error.subject)}>{error.question_type}</a>
          newerror['stars'] = <ReactStars count={5} value={ error.master_degree } size={14} color2={'#ffd700'}/>
          newerror['tag_list'] = tag_list;
          results.push(newerror)
        })
        if (results.length>0) {
          this.setState({'errors':results})
        }
    }
  }

  showErrorDetail(event) {
    event.preventDefault();
    this.props.showErrorDetail(event);
    this.props.history.push(`/errorview`);
  }

  onPrintClick() {
    if (this.props.errors.length>0) {
      var question = '';
      this.props.errors.forEach((err)=>{
        question = question + '<div><p><b>' + err.id + '</b>|<b>' + err.ddate + ' </b>|<b> ' + err.source + ' </b>|<b> ' + err.question_type + '</b></p>';
        if (err.question_txt !== null) {
          question = question + '<p>' + err.question_txt + '</p>';
        };
        if (err.question_img1 !== null) {
          question = question + '<img width=650 src=' + err.question_img1 + ' /><br/>';
        }
        if (err.question_img2 !== null) {
          question = question + '<img width=650 src=' + err.question_img2 + ' /><br/>';
        }
        question = question + '</div><hr/>';
      });

      /* Print */
      var printWindow = window.open('','','height=400,width=800');
      printWindow.document.write('<html><head><title>Errors</title>');
      printWindow.document.write('<link rel="stylesheet" href="style.css" />');
      printWindow.document.write('</head><body>');
      printWindow.document.write(question);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      /*printWindow.print();*/
      printWindow.onload = function(){printWindow.print();};
    }
  }

  onPrintAnswerClick() {
    if (this.props.errors.length>0) {
      var question = '';
      this.props.errors.forEach((err)=>{
        question = question + '<div><p><b>' + err.id + '</b>|<b>' + err.ddate + ' </b>|<b> ' + err.source + ' </b>|<b> ' + err.question_type + '</b></p>';
        question = question + '<p>题目：</p>';
        if (err.question_txt !== null) {
          question = question + '<p>' + err.question_txt + '</p>';
        };
        if (err.question_img1 !== null) {
          question = question + '<img width=650 src=' + err.question_img1 + ' /><br/>';
        }
        if (err.question_img2 !== null) {
          question = question + '<img width=650 src=' + err.question_img2 + ' /><br/>';
        }
        question = question + '<p>你的答案：</p>';
        if (err.error_answer_txt !== null) {
          question = question + '<p>' + err.error_answer_txt + '</p>';
        };
        if (err.error_answer_img1 !== null) {
          question = question + '<img width=650 src=' + err.error_answer_img1 + ' /><br/>';
        }
        if (err.error_answer_img2 !== null) {
          question = question + '<img width=650 src=' + err.error_answer_img2 + ' /><br/>';
        }
        question = question + '<p>正确答案：</p>';
        if (err.correct_answer_txt !== null) {
          question = question + '<p>' + err.correct_answer_txt + '</p>';
        };
        if (err.correct_answer_img1 !== null) {
          question = question + '<img width=650 src=' + err.correct_answer_img1 + ' /><br/>';
        }
        if (err.correct_answer_img2 !== null) {
          question = question + '<img width=650 src=' + err.correct_answer_img2 + ' /><br/>';
        }
        if (err.method !== null) {
          question = question + '<p>解析：</p><p>' + err.method + '</p>';
        };
        question = question + '</div><hr/>';
      });

      /* Print */
      var printWindow = window.open('','','height=400,width=800');
      printWindow.document.write('<html><head><title>Errors</title>');
      printWindow.document.write('<link rel="stylesheet" href="style.css" />');
      printWindow.document.write('</head><body>');
      printWindow.document.write(question);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      /*printWindow.print();*/
      printWindow.onload = function(){printWindow.print();};
    }
  }

  onFilerClick(filter) {
    this.setState({errors:[]});
    if (filter.includes('subject=')) {
      this.setState({currentSubject:parseInt(filter.split('subject=')[1],0)});
    }
    this.props.fetchErrorsFilter(this.props.userinfo.token,filter);
  }

  addSubjectClick() {
    /* Add Subject */
    if ('token' in this.props.userinfo) {
      var subjectName = prompt("请输入科目名称（如语文、数学……）:",'')
      if (subjectName !== null && subjectName !== "") {
        this.props.newSubject(this.props.userinfo.token, subjectName);
        this.props.fetchSubjects(this.props.userinfo.token)
      }
    } else {
      alert('请先登录或注册。');
      this.props.history.push(`/user_login`);
    }
  }

  render() {
    var subjects_href = [];
    /* 插入科目链接 */
    if (Object.keys(this.props.subjects) !== 0){
      if (this.props.subjects.length>0) {
        this.props.subjects.forEach((subject)=>{
          subjects_href.push(
            <a
              key={subject.id}
              id={subject.id}
              nohref="true"
              onClick={()=>this.onFilerClick('subject='+subject.id)}
            >
              &nbsp;
              {subject.id===this.state.currentSubject ? <u>{subject.name}</u> : subject.name }
            </a>)
        })
      }
      /* 插入新增课程科目 */
      if (Object.keys(this.props.subject).length !==0 ) {
        var id = this.props.subject.id;
        /* console.log(Object.keys(this.props.subjects)); */
        if (Object.keys(this.props.subjects).length !== 0 && ! ('detail' in this.props.subjects)) {
          var hitSubject = this.props.subjects.find(subject=>parseInt(subject.id,0)===parseInt(id,0));
        }
        if (('token' in this.props.userinfo) && (typeof hitSubject === "undefined")) {
          subjects_href.push(
            <a
              key = { id }
              id = { id }
              nohref = "true"
              onClick = {()=>this.onFilerClick('subject='+id)}
            >
              &nbsp;{this.props.subject.name}
            </a>
          )
        }
      }
    }
    
    return (
      <Panel>
        <Panel.Heading>
          <h3>错题列表
          <small>{subjects_href}</small>
          <Button bsSize="xsmall" onClick={this.addSubjectClick} style={{"float":"right"}}>
            新增科目
          </Button>
          </h3>
        </Panel.Heading>
        <Panel.Body>
          <BootstrapTable
            keyField = 'id'
            data = { this.state.errors }
            columns = { this.state.columns }
            striped
            hover
            noDataIndication = '没有可以显示的数据'
            pagination = { paginationFactory({page:1}) }
          />
        </Panel.Body>
        <Panel.Footer>
          {
            (Object.keys(this.props.errors)!==0)?(this.props.errors.length>0 ? 
              (<div>
                <Button onClick={this.onPrintClick}>打印错题</Button>
                <Button onClick={this.onPrintAnswerClick}>打印错题（含答案）</Button>
              </div>)
              : 
              '')
              :
              ''
          }
        </Panel.Footer>
      </Panel>
    );
  }
}

ErrorsList.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  fetchTagCounts: propsTypes.func.isRequired,
  fetchSubjects: propsTypes.func.isRequired,
  fetchErrorsFilter: propsTypes.func.isRequired,
  newSubject: propsTypes.func.isRequired,
  subjects: propsTypes.list,
  subject:propsTypes.object,
  errors: propsTypes.list,
  userinfo: propsTypes.object,
  tags: propsTypes.list,
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  subjects: state.subjects.items,
  subject: state.subjects.item,
  tags: state.tags.items,
  errors: state.errors.items,
})

export default withRouter(
  connect(
    mapStateToProps,{
      loginUser, 
      logoutUser, 
      registerUser, 
      fetchTagCounts,
      fetchSubjects,
      newSubject,
      fetchErrorsFilter
    }
  )(ErrorsList)
);


// WEBPACK FOOTER //
// ./src/components/ErrorsList.js